import http from "../../utils/http";
import { toast } from "../../utils/toast";

// 직급 조회
export const getGradeList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/grades/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 직급 등록하기
export const createGrades = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/grades", body)
      .then((res) => {
        toast.success("직급이 등록되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 직급 개편
export const createGradesOrganize = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/grades/organize", body)
      .then((res) => {
        toast.success("직급 개편이 완료되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 직급 삭제하기
export const deleteGrades = (gradeIdx, data = {}) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/grades/${gradeIdx}`, { data })
      .then((res) => {
        toast.success("직급이 삭제되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 직급 수정하기
export const updateGrades = (gradeIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/grades/${gradeIdx}`, body)
      .then((res) => {
        toast.success("직급이 수정되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
